import { useState } from 'react'
import type { SlotState } from './drop-slot'
import { deckErrorText } from './errors'
import { fileProblem } from './use-file-drop'

export type QueueItem = { key: string | null; file: File }

export function useUploadQueue(send: (key: string, file: File) => Promise<unknown>) {
  const [state, setState] = useState<Map<string, SlotState>>(new Map())
  const [report, setReport] = useState<string[]>([])
  const [progress, setProgress] = useState<{ done: number; total: number } | null>(null)
  const mark = (key: string, value: SlotState) => setState((old) => new Map(old).set(key, value))

  const run = async (items: QueueItem[]) => {
    setState(new Map())
    const problems: string[] = []
    const ready: { key: string; file: File }[] = []
    for (const { key, file } of items) {
      const problem = fileProblem(file)
      if (problem) {
        problems.push(problem)
        if (key) mark(key, 'bad')
      } else if (!key) {
        problems.push(`${file.name}: не удалось определить карту по имени, перетащите файл на нужный слот`)
      } else {
        ready.push({ key, file })
      }
    }
    setReport(problems)
    if (ready.length === 0) return
    setState((old) => {
      const next = new Map(old)
      for (const r of ready) next.set(r.key, 'busy')
      return next
    })
    setProgress({ done: 0, total: ready.length })
    for (const [i, { key, file }] of ready.entries()) {
      try {
        await send(key, file)
        mark(key, 'done')
      } catch (e) {
        mark(key, 'bad')
        problems.push(`${file.name}: ${deckErrorText(e)}`)
        setReport([...problems])
      }
      setProgress({ done: i + 1, total: ready.length })
    }
    setProgress(null)
  }

  return { state, report, progress, busy: progress !== null, run: (items: QueueItem[]) => void run(items) }
}
